import { useMemo } from "react";

import { EmptystateSearchNoResultsColored } from "components/icons/generated";
import ListEntitiesItem from "components/ListEntitiesItem";
import ListEntitiesItemLink from "components/ListEntitiesItem/Link";
import SortableTable, { SortableTableColumn } from "components/SortableTable";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import PageInfoHeader from "ds/components/PageInfoHeader";
import useTypedContext from "hooks/useTypedContext";
import { SearchQueryOrderDirection } from "types/generated";

import { VersionContext } from "../Context";

const columns: SortableTableColumn[] = [
  {
    value: "name",
    label: "Name",
  },
];

const ModuleVersionExamples = () => {
  const { version } = useTypedContext(VersionContext);

  const examples = useMemo(() => version?.metadata?.examples || [], [version]);

  return (
    <>
      <PageInfoHeader title="Examples" />
      {examples.length === 0 && (
        <EmptyState
          fullHeight
          icon={EmptystateSearchNoResultsColored}
          caption="This module has no examples"
        />
      )}
      {examples.length > 0 && (
        <SortableTable
          ariaLabel="Examples"
          items={examples}
          columns={columns}
          columnOrder="1fr"
          renderItems={(sorted) =>
            sorted.map((item) => (
              <ListEntitiesItem role="row" key={item.name}>
                <Box role="rowheader">
                  <ListEntitiesItemLink title={item.name} href={`./../example/${item.name}`} />
                </Box>
              </ListEntitiesItem>
            ))
          }
          initialSortBy="name"
          initialDirection={SearchQueryOrderDirection.Desc}
        />
      )}
    </>
  );
};

export default ModuleVersionExamples;
